export default __webpack_public_path__ + "static/media/buy_new_icon.afe019b4.svg";